import { twMerge } from "tailwind-merge";
import { Divider } from "./Divider";

interface CommentItemProps {
  profileImg: string;
  name: string;
  content: string;
  date: string;
  // onReply?: () => void;
  replies?: CommentItemProps[]; // 대댓글 지원
  // isReply?: boolean; // 대댓글 여부
}

const CommentItem: React.FC<CommentItemProps> = ({
  profileImg,
  name,
  content,
  date,
  // onReply,
  // replies,
  // isReply,
}) => {
  return (
    <div className={twMerge()}>
      <div className={twMerge("flex gap-2 items-center mb-1")}>
        <img src={profileImg} alt={name} className="w-5 h-5 rounded-full" />
        <span className="font-bold text-s">{name}</span>
      </div>
      <div className={twMerge("pl-7")}>
        <div className="text-gray-700 text-s">{content}</div>
        <div className="flex gap-2 items-center mt-1 text-gray-400 text-s">
          <span>{date}</span>
          {/* <button className="ml-2" onClick={onReply}>
            답글쓰기
          </button> */}
        </div>
      </div>
      <Divider className="my-4 bg-gray-200" line />
      {/* 대댓글 렌더링 */}
      {/* {replies && replies.length > 0 && (
        <div>
          {replies.map((reply, idx) => (
            <CommentItem key={idx} {...reply} isReply={true} />
          ))}
        </div>
      )} */}
    </div>
  );
};

export default CommentItem;
